if (typeof jQuery != "undefined")
    window.jQueryCloudCarousel = jQuery.noConflict()
